module.exports = __webpack_public_path__ + "img/cv.b545dc95.jpg";